import axios, { InternalAxiosRequestConfig } from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import * as Constants from '../../constants';
import { RecipeService } from './recipe';
import { CategoryService } from './category';
import { CuisineService } from './cuisine';
import { S3UploadService } from './s3upload';


const api = axios.create({
  baseURL: Constants.COCINERO0_API_URL,
})

const ax = axios.create()

const requestHandler = async (request: InternalAxiosRequestConfig) => {
 try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    if (idToken) {
      request.headers.Authorization = `Bearer ${idToken.toString()}`;
    }
  } catch (_) {
    // handle error
  }
  return request;
};

api.interceptors.request.use(requestHandler);

export const Api = Object.freeze({
  Recipe: new RecipeService({
    api: api,
  }),
  Category: new CategoryService({
    api: api,
  }),
  Cuisine: new CuisineService({
    api: api,
  }),
  S3Upload: new S3UploadService({
    axios: ax,
  }),
});
